import { render } from "./ProcessIndex.vue?vue&type=template&id=08b92d06&scoped=true"
import script from "./ProcessIndex.vue?vue&type=script&lang=js"
export * from "./ProcessIndex.vue?vue&type=script&lang=js"

import "./ProcessIndex.vue?vue&type=style&index=0&id=08b92d06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b92d06"]])

export default __exports__